
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import "@/components/ui/dialog.jsx";
import { validateReactImports } from './utils/reactImportCheck';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('ServiceWorker registration successful');
      })
      .catch(err => {
        console.log('ServiceWorker registration failed: ', err);
      });
  });
}

// Enable Lovable features
window.__LOVABLE_APP__ = true;

// Validate React imports in development
validateReactImports();

ReactDOM.createRoot(document.getElementById("root")).render(
    <App />
);
